import { setHeader } from 'h3'
import { findGlobalRedirect, type GlobalRedirect } from '~/utils/globalRedirect'

export default defineNuxtRouteMiddleware(async (to) => {
  try {
    const { $client } = useNuxtApp()

    // get global redirect
    const response = await $client.withoutUnresolvableLinks.getEntry(
      '5US83uannV96QPXZ2neuuN',
      {
        include: 10,
      },
    )

    const redirects = response?.fields?.globalRedirect as GlobalRedirect[]

    const found = findGlobalRedirect(redirects, to)

    if (found) {
      const requestEvent = useRequestEvent()
      if (requestEvent)
        setHeader(
          requestEvent,
          'Cache-Control',
          'no-cache, no-store, must-revalidate',
        )
      return navigateTo(found.to, {
        redirectCode: parseInt(String(found.statusCode || '301'), 10),
        external: /^https?:\/\//.test(found.to || ''),
      })
    }
  } catch (error) {
    console.log(error)
  }
})
